<div [style.height.px]="height()" [style.width.px]="width()" class="drawing">
    <canvas id="canvasImage" #canvasImage></canvas>
    <canvas id="canvas" #canvas></canvas>
</div>
